export enum AppointmentParticipantStatusEnum {
  REGISTERED = 'REGISTERED',
  SCANNED = 'SCANNED',
  NON_REGISTERED_SCANNED = 'NON_REGISTERED_SCANNED',
  WAITLIST = 'WAITLIST'
}
